import axiosInstance from '../../services/axios/axios';
import Apps from '../../Classes/ResponseModels/Apps';

export const GetApplicationsInfoIndex = async () => {
	try {
		const response = await axiosInstance.get(`api/Applications/Info`);
		return new Apps(response.data);
	} catch (ex) {
		console.error('Unable to fetch Applications info: ' + ex);
		return {
			data: {},
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const GetApplicationsInfoDetails = async appID => {
	try {
		const response = await axiosInstance.get(
			`api/Applications/Info/${appID}`
		);

		return new Apps(response.data);
	} catch (ex) {
		console.error('Unable to to fetch App info details: ' + ex);
		return {
			data: {},
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const UpdateApplicationInformation = async appModel => {
	try {
		const response = await axiosInstance.post(
			`api/Applications/Info/update`,
			appModel
		);
		return new Apps(response.data);
	} catch (ex) {
		console.error(
			`unable to update app info for app master id: ${appModel.id} `
		);
	}
};

export const UserCanEditAppInfoPage = async (esoID, upmcAppID) => {
	try {
		const response = await axiosInstance.get(
			`api/Applications/Info/PermissionCheck?esoID=${esoID}&upmcAppID=${upmcAppID}`
		);
		return response.data;
	} catch (ex) {
		console.error(
			'Unable to determine if user can edit application information: ' +
				ex
		);
		return {
			data: false,
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const GetLocationOptions = async () => {
	try {
		const response = await axiosInstance.get('api/Locations');
		return response.data;
	} catch (ex) {
		console.error(
			'Unable to determine if user can edit application information: ' +
				ex
		);
		return {
			data: false,
			error: 'An Error Occured Fetching data from the server',
		};
	}
};

export const GetContactOptions = async searchTerm => {
	try {
		const response = await axiosInstance.get(
			`api/ESO/SearchByName?search=${searchTerm}`
		);
		return response.data;
	} catch (ex) {
		console.error(
			`Unable to retreive Contact Options: search term: ${searchTerm} - ` +
				ex
		);
		return {
			data: null,
			error: 'an error occured fetching contact options from server',
		};
	}
};
